"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var DropdownWithExpandBtn_1 = __importDefault(require("atomicComponents/organisms/Dropdown/DropdownWithExpandBtn"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var context_1 = require("../context");
var CustomerActionsDropdown = function (_a) {
    var item = _a.item;
    var openModal = react_1.default.useContext(context_1.BillingModalContext);
    if (item.isRechargeEnabled || !item.rechargerCompany.rechargesNextInvoiceDate || item.isArchived) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(DropdownWithExpandBtn_1.default, __assign({ closeOnClick: true }, { children: (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Enable Customer", autoFocus: true, disabled: !item.primaryContactEmail, description: item.primaryContactEmail ? undefined : 'Can’t enable customers without email address', onClick: function () { return openModal === null || openModal === void 0 ? void 0 : openModal({ modalKey: 'enable_billing', item: item, itemId: item.id }); } }) })));
};
exports.default = CustomerActionsDropdown;
